var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureChallenge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16675,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16675,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3291_28303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 18C23.0097 18 21.6667 16.657 21.6667 15C21.6667 13.343 23.0097 12 24.6667 12C26.3237 12 27.6667 13.343 27.6667 15C27.6667 16.657 26.3237 18 24.6667 18Z",
    fill: "#82C100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 31C17.5617 31 16.6667 30.105 16.6667 29V23C16.6667 21.87 17.0577 20.838 17.6927 20H14.6667C13.5617 20 12.6667 20.895 12.6667 22V27C12.6667 27.552 13.1147 28 13.6667 28H14.6667V33C14.6667 33.552 15.1147 34 15.6667 34H17.6667C18.2187 34 18.6667 33.552 18.6667 33V31Z",
    fill: "#82C100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 36H22.6667C22.1147 36 21.6667 35.552 21.6667 35V29H19.6667C19.1147 29 18.6667 28.552 18.6667 28V23C18.6667 21.343 20.0097 20 21.6667 20H27.6667C29.3237 20 30.6667 21.343 30.6667 23V28C30.6667 28.552 30.2187 29 29.6667 29H27.6667V35C27.6667 35.552 27.2187 36 26.6667 36Z",
    fill: "#82C100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 19C15.5617 19 14.6667 18.105 14.6667 17C14.6667 15.895 15.5617 15 16.6667 15C17.7717 15 18.6667 15.895 18.6667 17C18.6667 18.105 17.7717 19 16.6667 19Z",
    fill: "#82C100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.667 31C31.772 31 32.667 30.105 32.667 29V23C32.667 21.87 32.276 20.838 31.641 20H34.667C35.772 20 36.667 20.895 36.667 22V27C36.667 27.552 36.219 28 35.667 28H34.667V33C34.667 33.552 34.219 34 33.667 34H31.667C31.115 34 30.667 33.552 30.667 33V31Z",
    fill: "#82C100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.667 19C33.772 19 34.667 18.105 34.667 17C34.667 15.895 33.772 15 32.667 15C31.562 15 30.667 15.895 30.667 17C30.667 18.105 31.562 19 32.667 19Z",
    fill: "#82C100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3291_28303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12.6667 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureChallenge);
export default __webpack_public_path__ + "static/media/feature_challenge.9afbf4899908ff29800f1ea51b371982.svg";
export { ForwardRef as ReactComponent };